import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VdiComponent } from './vdi.component';
import { VdiRoutingModule } from './vdi-routing.module';
import { VdiService } from './vdi.service';
import { SharedModule } from '../shared/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { FileUploadModule } from 'ng2-file-upload';
import { MatRadioModule } from '@angular/material/radio';

@NgModule({
  imports: [VdiRoutingModule, CommonModule, SharedModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatRadioModule, FileUploadModule],
  declarations: [VdiComponent],
  exports: [VdiComponent],
  providers: [VdiService]
})
export class VdiModule { }
